// --- START OF FILE src/index.js ---

import React, { Suspense } from 'react'; // MODIFICACIÓN: Importar Suspense
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import App from './App';
import './config/i18n'; // MODIFICACIÓN: Importar la configuración de i18next
import './index.css';
import './styles/Global.css';

import { db, auth, storage, functions } from './firebase'; // MODIFIED THIS LINE
import { doc, onSnapshot, collection, query, where, orderBy, getDocs, Timestamp } from 'firebase/firestore'; // MODIFIED THIS LINE
import { ref, getDownloadURL } from "firebase/storage"; // ADDED THIS LINE
import { httpsCallable } from 'firebase/functions'; // ADDED THIS LINE
import { openDB } from 'idb'; // ADDED THIS LINE
import * as Recharts from 'recharts'; // ADDED
import useRealtimeDocument from './hooks/useRealtimeDocument';
import reportWebVitals from './reportWebVitals';

console.log('RESEYE Web Client v1.0.3 initialized');

// --------- INICIO DE MODIFICACIÓN PARA PRUEBA -----------
// Exponer React globalmente de forma explícita
if (typeof window !== 'undefined') {
  window.React = React;
  console.log('Manually exposed React to window object in src/index.js');
}
// --------- FIN DE MODIFICACIÓN PARA PRUEBA -----------

// --------- INICIO DE MODIFICACIÓN PARA EXPOSICIÓN DE FIREBASE -----------
// Exponer instancias de Firebase globalmente de forma explícita
if (typeof window !== 'undefined') {
  window.RESEYE_FIREBASE = {
    db: db,
    auth: auth,
    storage: storage,
    functions: functions, // ADDED
    doc: doc,
    ref: ref, // ADDED
    getDownloadURL: getDownloadURL, // ADDED
    onSnapshot: onSnapshot,
    collection: collection, // ADDED
    query: query, // ADDED
    where: where, // ADDED
    orderBy: orderBy, // ADDED
    getDocs: getDocs, // ADDED
    Timestamp: Timestamp, // ADDED
    httpsCallable: httpsCallable, // ADDED
  };
  console.log('Manually exposed Firebase instances to window.RESEYE_FIREBASE object in src/index.js');

  window.RESEYE_HOOKS = {
    useRealtimeDocument: useRealtimeDocument,
  };
  console.log('Manually exposed custom hooks to window.RESEYE_HOOKS object in src/index.js');

  window.RESEYE_LIBS = {
    openDB: openDB, // ADDED
    Recharts: Recharts, // ADDED
  };
  console.log('Manually exposed 3rd party libs to window.RESEYE_LIBS object in src/index.js');
}
// --------- FIN DE MODIFICACIÓN PARA EXPOSICIÓN DE FIREBASE -----------



// Componente de Fallback para Suspense mientras se cargan las traducciones
const LoadingTranslations = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#161616', // O usa var(--bg-primary) si index.css ya está cargado
    color: '#ffffff',           // O usa var(--text-primary)
    fontFamily: '"Source Sans Pro", sans-serif'
  }}
  >
    Loading...
    {/* Podrías poner aquí el mismo loader que usas en App.jsx para 'cargando' */}
  </div>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* MODIFICACIÓN: Envolver la App (o la parte que usa traducciones) con Suspense */}
    <Suspense fallback={<LoadingTranslations />}>
      <BrowserRouter>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </Suspense>
  </React.StrictMode>
);

reportWebVitals();
// v1.0.2
// --- END OF FILE src/index.js ---
